import { render, staticRenderFns } from "./CandidateEmployeeCard.vue?vue&type=template&id=e4e003b4&scoped=true"
import script from "./CandidateEmployeeCard.vue?vue&type=script&lang=ts"
export * from "./CandidateEmployeeCard.vue?vue&type=script&lang=ts"
import style0 from "./CandidateEmployeeCard.vue?vue&type=style&index=0&id=e4e003b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e003b4",
  null
  
)

export default component.exports